"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteStyleToolBar = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_1 = require("mobx");
var Types_1 = require("DataStores/Account/Types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var LegacyToolbarShim_1 = require("Toolbar/LegacyToolbarShim");
var QuoteStyleSection_1 = __importDefault(require("./QuoteStyleSection"));
var QuoteStyleToolBar = (function (_super) {
    __extends(QuoteStyleToolBar, _super);
    function QuoteStyleToolBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showStyleSection = false;
        _this.toggleStyleSectionDisplay = function () {
            _this.showStyleSection = !_this.showStyleSection;
            if (_this.showStyleSection) {
                _this.props.telemetry.track("Block Styles Contextual Viewed", {}, {
                    blockIntercom: true,
                });
            }
        };
        _this.getToolbarIcon = function (icon) {
            if (typeof icon === "string") {
                var iconElem = {
                    delete: react_1.default.createElement(icons_1.Delete, null),
                    "arrow-up": react_1.default.createElement(icons_1.ArrowUp, null),
                    "arrow-down": react_1.default.createElement(icons_1.ArrowDown, null),
                    clone: react_1.default.createElement(icons_1.Copy, null),
                }[icon];
                if (iconElem == undefined) {
                    throw new Error("Got unknown toolbar icon name: \"".concat(icon, "\""));
                }
                return iconElem;
            }
            return icon;
        };
        _this.getToolBarOptions = function () {
            var _a = _this.props, options = _a.options, stylePermissionStore = _a.stylePermissionStore;
            var toolbarOptions = options.map(function (option) { return (__assign(__assign({}, option), { icon: _this.getToolbarIcon(option.icon), selected: undefined })); });
            if (stylePermissionStore.allowStyle(Types_1.StyleAccessType.ToolbarQuote)) {
                var styleOption = {
                    value: "style",
                    hint: "section style",
                    onClick: _this.toggleStyleSectionDisplay,
                    icon: react_1.default.createElement(icons_1.Styles, null),
                    selected: _this.showStyleSection,
                };
                toolbarOptions.splice(options.length - 1, 0, styleOption);
            }
            return toolbarOptions;
        };
        return _this;
    }
    QuoteStyleToolBar.prototype.render = function () {
        var showStyleSection = this.showStyleSection;
        return (react_1.default.createElement("div", { className: "quote-accept-toolbar" },
            react_1.default.createElement(kaleidoscope_1.Toolbar, { visible: true, positionType: kaleidoscope_1.ToolbarPositionType.None }, this.getToolBarOptions().map(LegacyToolbarShim_1.shimLegacyToolbarOption)),
            showStyleSection && (react_1.default.createElement(QuoteStyleSection_1.default, { brandStore: this.props.brandStore, blockStore: this.props.blockStore, telemetry: this.props.telemetry }))));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], QuoteStyleToolBar.prototype, "showStyleSection", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], QuoteStyleToolBar.prototype, "toggleStyleSectionDisplay", void 0);
    QuoteStyleToolBar = __decorate([
        mobx_react_1.observer
    ], QuoteStyleToolBar);
    return QuoteStyleToolBar;
}(react_1.default.Component));
exports.QuoteStyleToolBar = QuoteStyleToolBar;
exports.default = QuoteStyleToolBar;
